import { RouteConfig } from 'vue-router';

import Teams from '@/views/team/List.vue';

export const teamsRoute: RouteConfig = {
  path: '',
  name: 'teams',
  component: Teams,
  meta: { authorized: true }
};
